export const s3bucket = "https://mindforce.s3.ap-south-1.amazonaws.com"

export const defaultPage = {
    total: 1,
    totalPages: 1,
    current_page: 1,
    perPage: 100,
    nextPage: null,
    previousPage: null
};